import {Component, HostListener, Input, OnInit} from '@angular/core';
import {Lightbox} from 'ngx-lightbox';
import {environment} from 'src/environments/environment';
import {ModalService} from '../../../../../shared/services/modal.service';

@Component({
    selector: 'product-gallery-default',
    templateUrl: './gallery-default.component.html',
    styleUrls: ['./gallery-default.component.scss']
})

export class GalleryDefaultComponent implements OnInit {

    @Input() product: any;
    @Input() type: any;
    @Input() adClass = 'product-gallery-vertical';

    paddingTop = '100%';
    currentIndex = 0;
    album = [];
    lightBoxOption = {
        showImageNumberLabel: true,
        centerVertically: true,
        showZoom: true,
        fadeDuration: .2,
        albumLabel: '%1 / %2'
    };

    SERVER_URL = environment.SERVER_URL;

    constructor(public lightBox: Lightbox, public modalService: ModalService) {
    }

    @HostListener('window:resize', ['$event'])
    closeLightBox(event: Event) {
        this.lightBox.close();
    }

    ngOnChanges() {
        this.album = [];

        if (this.type == 'images') {
            this.album.push({
                src: this.product.preview,
                thumb: this.product.thumbnail,
                caption: this.product.caption
            });
        }
        // }
    }

    ngOnInit(): void {
        // this.paddingTop = Math.floor((parseFloat(this.product.pictures[0].height.toString()) / parseFloat(this.product.thumbnail.width.toString()) * 1000)) / 10 + '%';

    }

    changeImage($event: Event, index = 0) {
        this.currentIndex = index;
        $event.preventDefault();
    }

    openLightBox() {
        if (this.type == 'images') {
            this.lightBox.open(this.album, this.currentIndex, this.lightBoxOption);
        }else {
            this.modalService.showVideoModal(this.product.preview);
        }
    }
}
